'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var accordion = require('../../../../../enums/accordion.js');
require('../../../../../enums/alert.js');
require('../../../../../enums/avatar.js');
require('../../../../../enums/breakpoints.js');
require('../../../../../enums/button.js');
require('../../../../../enums/code-editor.js');
require('../../../../../enums/colors.js');
require('../../../../../enums/combobox.js');
require('../../../../../enums/date.js');
require('../../../../../enums/drag-and-drop.js');
require('../../../../../enums/dialog.js');
require('../../../../../enums/divider.js');
require('../../../../../enums/dropdown.js');
require('../../../../../enums/fieldset.js');
require('../../../../../enums/font-icon.js');
require('../../../../../enums/fonts.js');
require('../../../../../enums/headings.js');
require('../../../../../enums/input.js');
require('../../../../../enums/keys.js');
require('../../../../../enums/list.js');
require('../../../../../enums/listbox.js');
require('../../../../../enums/loader.js');
require('../../../../../enums/margin.js');
require('../../../../../enums/option.js');
require('../../../../../enums/pill.js');
require('../../../../../enums/placements.js');
require('../../../../../enums/popout.js');
require('../../../../../enums/privacy.js');
require('../../../../../enums/radio-group.js');
require('../../../../../enums/status.js');
require('../../../../../enums/switch.js');
require('../../../../../enums/table.js');
require('../../../../../enums/tooltip.js');
require('../../../../../enums/transitions.js');
require('../../../../../enums/widths.js');
var accordionHeader_module = require('../styles/accordion-header.module.scss.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Accordion header with heading, button, and any before/after content.
 * @param {AccordionHeaderComponentProps} props AccordionHeaderComponentProps
 */ const AccordionHeader = (props)=>{
    const { accordionPanelId , buttonIcon , buttonIconPosition =accordion.AccordionButtonIconPositions.Before , buttonProps , children , disabled , focusIndex , headerContent , headerContentPosition =accordion.AccordionHeaderContentPositions.After , headerProps , headingLevel =accordion.AccordionHeadingLevels.H3 , headingProps , id , index , onChange , onKeyUp , open , showText =true  } = props;
    const ref = React.useRef(null);
    React.useEffect(()=>{
        if (focusIndex !== null && focusIndex === index && ref?.current) {
            ref.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        focusIndex
    ]);
    const HeadingTag = headingLevel;
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, headerProps, {
        className: classnames__default.default('accordion-header', accordionHeader_module.accordionHeader, headerProps?.className)
    }), headerContent && headerContentPosition === accordion.AccordionHeaderContentPositions.Before ? headerContent : null, /*#__PURE__*/ React__default.default.createElement(HeadingTag, _extends({}, headingProps, {
        className: classnames__default.default('accordion-heading', accordionHeader_module.accordionHeading, headingProps?.className)
    }), /*#__PURE__*/ React__default.default.createElement("button", _extends({}, buttonProps, {
        ref: ref,
        "aria-controls": accordionPanelId,
        "aria-disabled": disabled,
        "aria-expanded": open,
        className: classnames__default.default('accordion-button', accordionHeader_module.accordionButton, buttonProps?.className),
        disabled: disabled,
        id: id,
        onClick: (e)=>{
            if (buttonProps && buttonProps.onClick) {
                buttonProps.onClick(e);
            }
            onChange(index);
        },
        onKeyUp: (e)=>{
            if (buttonProps && buttonProps.onKeyUp) {
                buttonProps.onKeyUp(e);
            }
            onKeyUp(e, index);
        },
        type: "button"
    }), buttonIcon && buttonIconPosition === accordion.AccordionButtonIconPositions.Before ? buttonIcon : null, /*#__PURE__*/ React__default.default.createElement("span", {
        className: classnames__default.default('accordion-button-text', accordionHeader_module.accordionButtonText, open ? 'isOpen' : 'isClosed', !showText && accordionHeader_module.srOnly)
    }, children), buttonIcon && buttonIconPosition === accordion.AccordionButtonIconPositions.After ? buttonIcon : null)), headerContent && headerContentPosition === accordion.AccordionHeaderContentPositions.After ? headerContent : null);
};

exports.AccordionHeader = AccordionHeader;
//# sourceMappingURL=accordion-header.js.map
